import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AddEventModal = ({ onAdd }) => {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [year, setYear] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const newEvent = {
      title,
      year: parseInt(year),
      description,
      categories: [category],
    };
    onAdd(newEvent);
    navigate('/timeline');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center">
      <div className="bg-card text-white p-6 rounded-xl w-full max-w-lg shadow-lg relative">
        <button
          onClick={() => navigate('/')}
          className="absolute top-2 right-3 text-white text-2xl hover:text-accent"
        >
          ×
        </button>

        <h2 className="text-2xl font-bold mb-4 text-center">Add New Event</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block mb-1 text-sm">Title</label>
            <input
              className="w-full px-3 py-2 bg-background border border-gray-600 rounded text-white"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block mb-1 text-sm">Year</label>
            <input
              type="number"
              className="w-full px-3 py-2 bg-background border border-gray-600 rounded text-white"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block mb-1 text-sm">Category</label>
            <input
              className="w-full px-3 py-2 bg-background border border-gray-600 rounded text-white"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block mb-1 text-sm">Description</label>
            <textarea
              className="w-full px-3 py-2 bg-background border border-gray-600 rounded text-white"
              rows="4"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 px-4 bg-accent text-black font-semibold rounded hover:bg-opacity-80 transition"
          >
            ➕ Add Event
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddEventModal;
